import { __decorate } from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { computed } from 'mobx';
import noop from 'lodash/noop';
import scrollIntoView from 'scroll-into-view-if-needed';
import { arrayMove } from 'choerodon-ui/pro/lib/data-set/utils';
import List from './list';
import Operation from './operation';
import SortButton from './SortButton';
import Search from './search';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import defaultLocale from '../locale-provider/default';
import { TransferDirection } from './enum';
import ConfigContext from '../config-provider/ConfigContext';
export { TransferListProps } from './list';
export { TransferOperationProps } from './operation';
export { TransferSearchProps } from './search';
export default class Transfer extends Component {
    constructor(props) {
        super(props);
        this.transferRef = null;
        this.moveTo = (direction) => {
            const { targetKeys = [], dataSource = [], onChange } = this.props;
            const { sourceSelectedKeys, targetSelectedKeys } = this.state;
            const moveKeys = direction === TransferDirection.right ? sourceSelectedKeys : targetSelectedKeys;
            // filter the disabled options
            const newMoveKeys = moveKeys.filter((key) => !dataSource.some(data => !!(key === data.key && data.disabled)));
            // move items to target box
            const newTargetKeys = direction === TransferDirection.right
                ? newMoveKeys.concat(targetKeys)
                : targetKeys.filter(targetKey => newMoveKeys.indexOf(targetKey) === -1);
            // empty checked keys
            const oppositeDirection = direction === TransferDirection.right ? TransferDirection.left : TransferDirection.right;
            this.setState({
                [this.getSelectedKeysName(oppositeDirection)]: [],
                sortKeys: null,
                highlightKey: '',
            });
            this.handleSelectChange(oppositeDirection, []);
            if (onChange) {
                onChange(newTargetKeys, direction, newMoveKeys);
            }
        };
        this.sortTo = (direction) => {
            const { prefixCls: customizePrefixCls } = this.props;
            const { highlightKey } = this.state;
            const to = direction === TransferDirection.up ? -1 : 1;
            const { rightDataSource } = this.splitDataSource();
            const mapRightKey = rightDataSource.map(x => x.key);
            const filterRightDataSource = this.computedRightDataSource;
            const filterCurrentIndex = filterRightDataSource.findIndex(x => x.key === highlightKey);
            const sourceIndex = rightDataSource.findIndex(x => x.key === highlightKey);
            const moveToOption = filterRightDataSource[filterCurrentIndex + to];
            const moveToIndex = rightDataSource.findIndex(x => x.key === moveToOption.key);
            arrayMove(mapRightKey, sourceIndex, moveToIndex);
            this.splitedDataSource = null;
            this.setState({
                sortKeys: mapRightKey,
            }, () => {
                // 向下移动位置，滚动条跟随
                if (this.transferRef) {
                    const { getPrefixCls } = this.context;
                    const prefixCls = getPrefixCls('transfer', customizePrefixCls);
                    const selectedCls = `${prefixCls}-list-content-item-highlight`;
                    const selectedDom = this.transferRef.getElementsByClassName(selectedCls)[0];
                    scrollIntoView(selectedDom, {
                        block: 'end',
                        behavior: 'smooth',
                        scrollMode: 'if-needed',
                        boundary: this.transferRef,
                    });
                }
            });
        };
        this.moveToLeft = () => this.moveTo(TransferDirection.left);
        this.moveToRight = () => this.moveTo(TransferDirection.right);
        this.moveToUp = () => this.sortTo(TransferDirection.up);
        this.moveToDown = () => this.sortTo(TransferDirection.down);
        this.handleSelectAll = (direction, filteredDataSource, checkAll) => {
            const { state, props: { selectedKeys }, } = this;
            const originalSelectedKeys = state[this.getSelectedKeysName(direction)] || [];
            const currentKeys = filteredDataSource.map(item => item.key);
            // Only operate current keys from original selected keys
            const newKeys1 = originalSelectedKeys.filter((key) => currentKeys.indexOf(key) === -1);
            const newKeys2 = [...originalSelectedKeys];
            currentKeys.forEach(key => {
                if (newKeys2.indexOf(key) === -1) {
                    newKeys2.push(key);
                }
            });
            const holder = checkAll ? newKeys1 : newKeys2;
            this.handleSelectChange(direction, holder);
            if (!selectedKeys) {
                this.setState({
                    [this.getSelectedKeysName(direction)]: holder,
                });
            }
        };
        this.handleLeftSelectAll = (filteredDataSource, checkAll) => this.handleSelectAll(TransferDirection.left, filteredDataSource, checkAll);
        this.handleRightSelectAll = (filteredDataSource, checkAll) => this.handleSelectAll(TransferDirection.right, filteredDataSource, checkAll);
        this.handleFilter = (direction, e) => {
            const { onSearchChange } = this.props;
            this.setState({
                // add filter
                [`${direction}Filter`]: e.target.value,
            });
            if (onSearchChange) {
                onSearchChange(direction, e);
            }
        };
        this.handleLeftFilter = (e) => this.handleFilter(TransferDirection.left, e);
        this.handleRightFilter = (e) => this.handleFilter(TransferDirection.right, e);
        this.handleClear = (direction) => {
            this.setState({
                [`${direction}Filter`]: '',
            });
        };
        this.handleLeftClear = () => this.handleClear(TransferDirection.left);
        this.handleRightClear = () => this.handleClear(TransferDirection.right);
        this.handleSelect = (direction, selectedItem, checked) => {
            const { selectedKeys } = this.props;
            const { sourceSelectedKeys, targetSelectedKeys } = this.state;
            const holder = direction === TransferDirection.left ? [...sourceSelectedKeys] : [...targetSelectedKeys];
            const index = holder.indexOf(selectedItem.key);
            if (index > -1) {
                holder.splice(index, 1);
            }
            if (checked) {
                holder.push(selectedItem.key);
            }
            this.handleSelectChange(direction, holder);
            if (!selectedKeys) {
                this.setState({
                    [this.getSelectedKeysName(direction)]: holder,
                });
            }
            if (direction === TransferDirection.right) {
                this.setState({
                    highlightKey: selectedItem.key,
                });
            }
        };
        this.handleLeftSelect = (selectedItem, checked) => {
            return this.handleSelect(TransferDirection.left, selectedItem, checked);
        };
        this.handleRightSelect = (selectedItem, checked) => {
            return this.handleSelect(TransferDirection.right, selectedItem, checked);
        };
        this.handleScroll = (direction, e) => {
            const { onScroll } = this.props;
            if (onScroll) {
                onScroll(direction, e);
            }
        };
        this.handleLeftScroll = (e) => this.handleScroll(TransferDirection.left, e);
        this.handleRightScroll = (e) => this.handleScroll(TransferDirection.right, e);
        this.renderTransfer = (locale) => {
            const { prefixCls: customizePrefixCls, className, operations = [], sortable = false, sortOperations = [], showSearch, notFoundContent, searchPlaceholder, body, footer, listStyle, filterOption, render, lazy, } = this.props;
            const { getPrefixCls } = this.context;
            const prefixCls = getPrefixCls('transfer', customizePrefixCls);
            const { leftFilter, rightFilter, sourceSelectedKeys, targetSelectedKeys, highlightKey, sortKeys, } = this.state;
            const { leftDataSource, rightDataSource } = this.splitDataSource(sortKeys);
            const leftActive = targetSelectedKeys.length > 0;
            const rightActive = sourceSelectedKeys.length > 0;
            const filterRightDataSource = this.computedRightDataSource;
            const mapRightKey = filterRightDataSource.map(x => x.key);
            const hasHighlight = !!highlightKey && mapRightKey.indexOf(highlightKey) > -1;
            const upActive = hasHighlight && mapRightKey.indexOf(highlightKey) !== 0;
            const downActive = hasHighlight && mapRightKey.indexOf(highlightKey) !== mapRightKey.length - 1;
            const cls = classNames(className, prefixCls);
            const titles = this.getTitles(locale);
            return (React.createElement("div", { className: cls, ref: dom => {
                    this.transferRef = dom;
                } },
                React.createElement(List, { prefixCls: `${prefixCls}-list`, titleText: titles[0], dataSource: leftDataSource, filter: leftFilter, filterOption: filterOption, style: listStyle, checkedKeys: sourceSelectedKeys, handleFilter: this.handleLeftFilter, handleClear: this.handleLeftClear, handleSelect: this.handleLeftSelect, handleSelectAll: this.handleLeftSelectAll, render: render, showSearch: showSearch, searchPlaceholder: searchPlaceholder || locale.searchPlaceholder, notFoundContent: notFoundContent || locale.notFoundContent, itemUnit: locale.itemUnit, itemsUnit: locale.itemsUnit, body: body, footer: footer, lazy: lazy, onScroll: this.handleLeftScroll }),
                React.createElement(Operation, { className: `${prefixCls}-operation`, rightActive: rightActive, rightArrowText: operations[0], moveToRight: this.moveToRight, leftActive: leftActive, leftArrowText: operations[1], moveToLeft: this.moveToLeft }),
                React.createElement(List, { prefixCls: `${prefixCls}-list`, titleText: titles[1], dataSource: rightDataSource, filter: rightFilter, filterOption: filterOption, style: listStyle, checkedKeys: targetSelectedKeys, highlightKey: highlightKey, handleFilter: this.handleRightFilter, handleClear: this.handleRightClear, handleSelect: this.handleRightSelect, handleSelectAll: this.handleRightSelectAll, render: render, showSearch: showSearch, searchPlaceholder: searchPlaceholder || locale.searchPlaceholder, notFoundContent: notFoundContent || locale.notFoundContent, itemUnit: locale.itemUnit, itemsUnit: locale.itemsUnit, body: body, footer: footer, lazy: lazy, onScroll: this.handleRightScroll }),
                !!sortable && (React.createElement(SortButton, { className: `${prefixCls}-sort`, upActive: upActive, upArrowText: sortOperations[0], moveToUp: this.moveToUp, downActive: downActive, downArrowText: sortOperations[1], moveToDown: this.moveToDown }))));
        };
        const { selectedKeys = [], targetKeys = [] } = props;
        this.state = {
            leftFilter: '',
            rightFilter: '',
            sourceSelectedKeys: selectedKeys.filter(key => targetKeys.indexOf(key) === -1),
            targetSelectedKeys: selectedKeys.filter(key => targetKeys.indexOf(key) > -1),
            highlightKey: '',
            sortKeys: null,
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    componentWillReceiveProps(nextProps) {
        const { sourceSelectedKeys, targetSelectedKeys } = this.state;
        const { props } = this;
        if (nextProps.targetKeys !== props.targetKeys || nextProps.dataSource !== props.dataSource) {
            // clear cached splited dataSource
            this.splitedDataSource = null;
            if (!nextProps.selectedKeys) {
                // clear key nolonger existed
                // clear checkedKeys according to targetKeys
                const { dataSource, targetKeys = [] } = nextProps;
                const newSourceSelectedKeys = [];
                const newTargetSelectedKeys = [];
                dataSource.forEach(({ key }) => {
                    if (sourceSelectedKeys.includes(key) && !targetKeys.includes(key)) {
                        newSourceSelectedKeys.push(key);
                    }
                    if (targetSelectedKeys.includes(key) && targetKeys.includes(key)) {
                        newTargetSelectedKeys.push(key);
                    }
                });
                this.setState({
                    sourceSelectedKeys: newSourceSelectedKeys,
                    targetSelectedKeys: newTargetSelectedKeys,
                });
            }
        }
        if (nextProps.selectedKeys) {
            const targetKeys = nextProps.targetKeys || [];
            this.setState({
                sourceSelectedKeys: nextProps.selectedKeys.filter(key => !targetKeys.includes(key)),
                targetSelectedKeys: nextProps.selectedKeys.filter(key => targetKeys.includes(key)),
            });
        }
    }
    splitDataSource(sortKeys) {
        if (this.splitedDataSource) {
            return this.splitedDataSource;
        }
        const { dataSource, rowKey, targetKeys = [] } = this.props;
        const useKeys = sortKeys || targetKeys;
        const leftDataSource = [];
        const rightDataSource = new Array(useKeys.length);
        dataSource.forEach(record => {
            if (rowKey) {
                record.key = rowKey(record);
            }
            // rightDataSource should be ordered by targetKeys
            // leftDataSource should be ordered by dataSource
            const indexOfKey = useKeys.indexOf(record.key);
            if (indexOfKey !== -1) {
                rightDataSource[indexOfKey] = record;
            }
            else {
                leftDataSource.push(record);
            }
        });
        this.splitedDataSource = {
            leftDataSource,
            rightDataSource,
        };
        return this.splitedDataSource;
    }
    get computedRightDataSource() {
        const { filterOption } = this.props;
        const { rightFilter } = this.state;
        const { rightDataSource } = this.splitDataSource();
        if (filterOption && rightFilter) {
            return rightDataSource.filter(opt => filterOption(rightFilter, opt));
        }
        return rightDataSource;
    }
    handleSelectChange(direction, holder) {
        const { onSelectChange } = this.props;
        const { sourceSelectedKeys, targetSelectedKeys } = this.state;
        if (!onSelectChange) {
            return;
        }
        if (direction === TransferDirection.left) {
            onSelectChange(holder, targetSelectedKeys);
        }
        else {
            onSelectChange(sourceSelectedKeys, holder);
        }
    }
    getTitles(transferLocale) {
        const { props } = this;
        if (props.titles) {
            return props.titles;
        }
        return transferLocale.titles;
    }
    getSelectedKeysName(direction) {
        return direction === TransferDirection.left ? 'sourceSelectedKeys' : 'targetSelectedKeys';
    }
    render() {
        return (React.createElement(LocaleReceiver, { componentName: "Transfer", defaultLocale: defaultLocale.Transfer }, this.renderTransfer));
    }
}
Transfer.displayName = 'Transfer';
Transfer.List = List;
Transfer.Operation = Operation;
Transfer.Search = Search;
Transfer.defaultProps = {
    dataSource: [],
    render: noop,
    showSearch: false,
};
Transfer.propTypes = {
    prefixCls: PropTypes.string,
    dataSource: PropTypes.array,
    render: PropTypes.func,
    targetKeys: PropTypes.array,
    onChange: PropTypes.func,
    listStyle: PropTypes.object,
    className: PropTypes.string,
    titles: PropTypes.array,
    operations: PropTypes.array,
    sortable: PropTypes.bool,
    sortOperations: PropTypes.array,
    showSearch: PropTypes.bool,
    filterOption: PropTypes.func,
    searchPlaceholder: PropTypes.string,
    notFoundContent: PropTypes.node,
    body: PropTypes.func,
    footer: PropTypes.func,
    rowKey: PropTypes.func,
    lazy: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};
__decorate([
    computed
], Transfer.prototype, "computedRightDataSource", null);
